/**
 * Binary float noise off a number that leaves the app as text: a sum read back
 * from Looker or a ratio computed here can print as 102842.51999999999 or
 * 0.015462033225239695. Fifteen significant digits is what a double holds
 * exactly, so this drops the noise and keeps every real digit
 * (102842.52, 0.0154620332252397). Integers pass through untouched.
 *
 * @module services/looker/lookerNumber
 */
export const withoutFloatNoise = (n: number): number =>
  Number.isFinite(n) && !Number.isInteger(n) ? Number(n.toPrecision(15)) : n;
